import React from 'react';
import styled from 'styled-components';

const Icon = styled.svg`
  width: 34px;
  height: 50px;

  @media (max-width: 767px) {
    height: 40px;
    width: 27px;
  }
`;

const FilterIcon = props => (
  <Icon
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 50"
    fill={props.fill}
  >
    <g>
      <path d="M1.73,19.49H3.38a2.18,2.18,0,0,0,.66,1,2.57,2.57,0,0,0,.75.43,2.17,2.17,0,0,0,.74.13h0a2.23,2.23,0,0,0,1.23-.39,2.61,2.61,0,0,0,.59-.58,2.25,2.25,0,0,0,.29-.57h9a.73.73,0,1,0,0-1.46h-9A2.2,2.2,0,0,0,7,17a2.56,2.56,0,0,0-.7-.42,2.26,2.26,0,0,0-2.82,1.13c0,.09-.08.18-.11.27H1.73a.73.73,0,1,0,0,1.46" />
      <path d="M16.64,24.27H14.81a2.2,2.2,0,0,0-.66-1,2.58,2.58,0,0,0-.7-.42,2.29,2.29,0,0,0-.66-.14,2.22,2.22,0,0,0-1.3.32,2.25,2.25,0,0,0-.87,1c0,.09-.08.18-.11.27H1.73a.73.73,0,0,0,0,1.46H10.5a2.18,2.18,0,0,0,.66,1,2.58,2.58,0,0,0,.75.43,2.17,2.17,0,0,0,.74.13h0a2.23,2.23,0,0,0,1.23-.39,2.59,2.59,0,0,0,.59-.58,2.25,2.25,0,0,0,.29-.57h1.84a.73.73,0,0,0,0-1.46" />
      <path d="M16.64,30.52h-6a2.19,2.19,0,0,0-.66-1,2.56,2.56,0,0,0-.7-.42A2.29,2.29,0,0,0,8.58,29a2.26,2.26,0,0,0-2.17,1.27c0,.09-.08.18-.11.27H1.73a.73.73,0,0,0,0,1.46H6.3A2.18,2.18,0,0,0,7,33a2.61,2.61,0,0,0,.75.43,2.16,2.16,0,0,0,.74.13h0a2.23,2.23,0,0,0,1.23-.39,2.58,2.58,0,0,0,.59-.58A2.25,2.25,0,0,0,10.6,32h6a.73.73,0,0,0,0-1.46" />
    </g>
  </Icon>
);

export default FilterIcon;
